// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__RZnOl","filesListContainer":"PosDisputesFiles_filesListContainer__ER-P4","filesButton":"PosDisputesFiles_filesButton__9Od7k"};